import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { VerifyBusinessFormContainer } from '@/components/organisms/VerifyBusinessFormContainer';
import { VerifyBusinessLayout } from '@/components/organisms/VerifyBusinessLayout';
import { VerifyBusinessSummary } from '@/components/organisms/VerifyBusinessSummary';
import { VerifyBusinessSummaryStep } from '@/components/organisms/VerifyBusinessSummaryStep';
import { useVerifyBusinessSteps } from '@/hooks/useVerifyBusinessSteps';

export const VerifyBusiness: React.FC = (): React.ReactElement => {
  const steps = useVerifyBusinessSteps();

  // Computes the relative path to the first step, works in both cases
  // summary and verify business
  const defaultPath = React.useMemo((): string => {
    const firstParent = steps[0];
    if (!firstParent) {
      throw new Error('verify business flow must not be empty');
    }

    const children = firstParent.children;
    if (children.length === 0) {
      return firstParent.path;
    }

    const firstChild = children[0];
    if (!firstChild) {
      throw new Error('first child of a parent with children must not be null | undefined');
    }

    return [firstParent.path, firstChild.path].join('/');
  }, [steps]);

  return (
    <Routes>
      <Route path="summary/*" element={<VerifyBusinessSummary />} />
      <Route path="summary/:parentId/:childId?" element={<VerifyBusinessSummary />}>
        <Route element={<VerifyBusinessSummaryStep />} index />
      </Route>
      <Route path="*" element={<Navigate to={defaultPath} />} />

      <Route path="" element={<VerifyBusinessLayout />} />
      <Route path=":parentId/:childId?" element={<VerifyBusinessLayout />}>
        <Route element={<VerifyBusinessFormContainer />} index />
      </Route>

      <Route path="*" element={<Navigate to={defaultPath} />} />
    </Routes>
  );
};
